export default "__VITE_ASSET__D1nd4ash__"